module.exports = __webpack_public_path__ + "static/media/crm_ilus.69538ae1.jpg";